/**
 * This method check for global popover attribute in window/document (HTMLElement) object
 */
export function isPopoverSupported() {
  return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype === 'object' && 'popover' in HTMLElement.prototype;
}
